import { useMemo, useState } from 'react';
import {
  matchesMyProjectsStatFilter,
  MY_PROJECTS_STAT_FILTER_ALL,
} from '../Utils/partnerMyProjectsUtils';

export const usePartnerFilters = (projects) => {
  const [search, setSearch] = useState('');
  const [status, setStatus] = useState(MY_PROJECTS_STAT_FILTER_ALL);

  const filteredProjects = useMemo(() => {
    return projects.filter((project) => {
      const statusPass = matchesMyProjectsStatFilter(project, status);
      const searchPass = search
        ? `${project.customerName} ${project.partnerName}`.toLowerCase().includes(search.toLowerCase())
        : true;
      return statusPass && searchPass;
    });
  }, [projects, search, status]);

  return {
    search,
    status,
    setSearch,
    setStatus,
    filteredProjects,
  };
};
